export function Reducer(state, action) {
  switch (action.type) {
    case 'load':
      return {
        ...state,
        payments: action.payments,
      };
    case 'pay':
      return {
        ...state,
        payments: state.payments.map((payment) => (payment.id == action.payment.id ? action.payment : payment)),
      };
    default:
      throw new Error();
  }
}
